const locales = {
  fa: 'fa',
  en: 'en',
  ko: 'ko',
}

const localeDirectionSettings = {
  [locales.fa]: {
    dir: 'rtl',
  },
  [locales.en]: {
    dir: 'ltr',
  },
  [locales.ko]: {
    dir: 'ltr',
  },
}
const LOCALE_IN_USE = process.env.REACT_APP_LOCALE

function isRTL() {
  if (LOCALE_IN_USE in localeDirectionSettings) {
    return localeDirectionSettings[LOCALE_IN_USE].dir === 'rtl'
  }

  throw new Error(
    'locale in use is not included in localeSettings, please check the settings.js'
  )
}

export const isRtl = isRTL()
export const localeDirection = localeDirectionSettings[LOCALE_IN_USE].dir

const localeSettings = {
  locales,
  localeSettings: localeDirectionSettings,
  LOCALE_IN_USE,
  isRtl,
}

// BCP language tag
const standardLocales = {
  [locales.fa]: 'fa-IR',
  [locales.en]: 'en-US',
  [locales.ko]: 'ko-KR',
}

export const getCurrentLocale = () => standardLocales[LOCALE_IN_USE]

export const isInternationalVersion = () => LOCALE_IN_USE !== 'fa'

export default localeSettings
